import { useQuery } from '@tanstack/react-query';
import { creatorDataQueries, PhylloUserAnalyticsData, TiktokUserAnalyticsData } from '@round/api';

const options = creatorDataQueries.tiktokUserAnalytics.options.detail;
const utils = creatorDataQueries.tiktokUserAnalytics.utils.detail;

type Config<TData> = Pick<ReturnType<typeof options>, 'enabled'> & {
    select?: (data: TiktokUserAnalyticsData) => TData;
};

export function useTiktokUserAnalytics<TData = PhylloUserAnalyticsData>(
    userId: number | undefined | null,
    config?: Config<TData>
) {
    const { data, isLoading, error, isError } = useQuery({
        ...options(userId),
        ...config,
        enabled: config?.enabled ?? !!userId,
        select: config?.select,
    });

    const errorMessage = error ? utils.getErrorMessage(error) : null;

    return { data, isLoading, error, errorMessage, isError };
}
